import { Link } from 'react-router-dom';
import { Scale, Phone, Mail, MapPin, Clock, ArrowUpRight } from 'lucide-react';

const footerLinks = {
  'Practice Areas': [
    { label: 'Corporate Law', path: '/practice-areas/corporate-law' },
    { label: 'Personal Injury', path: '/practice-areas/personal-injury' },
    { label: 'Family Law', path: '/practice-areas/family-law' },
    { label: 'Real Estate', path: '/practice-areas/real-estate' },
    { label: 'Estate Planning', path: '/practice-areas/estate-planning' },
    { label: 'Immigration Law', path: '/practice-areas/immigration' },
  ],
  'Services': [
    { label: 'Book Consultation', path: '/consultation' },
    { label: 'Client Portal', path: '/portal' },
    { label: 'Legal Resources', path: '/resources' },
    { label: 'Contact Us', path: '/contact' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-[#050d1a] border-t border-[#c9a84c]/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 bg-gradient-to-br from-[#c9a84c] to-[#b08e2e] rounded-lg flex items-center justify-center">
                <Scale className="w-5 h-5 text-[#0a1628]" />
              </div>
              <div>
                <span className="text-lg font-bold" style={{ fontFamily: 'Playfair Display, serif' }}>
                  Summit <span className="text-[#c9a84c]">Legal</span>
                </span>
                <div className="text-[10px] tracking-[0.2em] text-[#c9a84c]/70 uppercase">Attorneys at Law</div>
              </div>
            </Link>
            <p className="text-[#e8e4dc]/60 text-sm leading-relaxed mb-6">
              Providing exceptional legal representation with integrity and excellence since 1998. Your trusted partner in navigating complex legal challenges.
            </p>
            <div className="flex items-center gap-3 text-sm text-[#c9a84c]">
              <Phone className="w-4 h-4" />
              <a href="tel:+12017984100" className="hover:text-[#e0cb82] transition-colors">(201) 798-4100</a>
            </div>
          </div>

          {/* Links */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-[#c9a84c] text-sm font-semibold tracking-wider uppercase mb-6">{title}</h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-sm text-[#e8e4dc]/60 hover:text-[#c9a84c] transition-colors flex items-center gap-1 group"
                    >
                      {link.label}
                      <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Contact Info */}
          <div>
            <h4 className="text-[#c9a84c] text-sm font-semibold tracking-wider uppercase mb-6">Office</h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3 text-sm text-[#e8e4dc]/60">
                <MapPin className="w-4 h-4 mt-0.5 text-[#c9a84c]/60 shrink-0" />
                <span>551 Summit Ave<br />Jersey City, NJ 07306</span>
              </div>
              <div className="flex items-center gap-3 text-sm text-[#e8e4dc]/60">
                <Phone className="w-4 h-4 text-[#c9a84c]/60 shrink-0" />
                <span>+1 (201) 798-4100</span>
              </div>
              <div className="flex items-center gap-3 text-sm text-[#e8e4dc]/60">
                <Mail className="w-4 h-4 text-[#c9a84c]/60 shrink-0" />
                <span>info@summitlegal.com</span>
              </div>
              <div className="flex items-start gap-3 text-sm text-[#e8e4dc]/60">
                <Clock className="w-4 h-4 mt-0.5 text-[#c9a84c]/60 shrink-0" />
                <span>Mon–Fri: 8:00 AM – 7:00 PM<br />Sat: By Appointment</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-[#c9a84c]/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-[#e8e4dc]/40">
            © 2026 Summit Legal Group. All rights reserved. Attorney advertising. Prior results do not guarantee a similar outcome.
          </p>
          <div className="flex gap-6 text-xs text-[#e8e4dc]/40">
            <span className="hover:text-[#c9a84c]/60 cursor-pointer transition-colors">Privacy Policy</span>
            <span className="hover:text-[#c9a84c]/60 cursor-pointer transition-colors">Terms of Service</span>
            <span className="hover:text-[#c9a84c]/60 cursor-pointer transition-colors">Disclaimer</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
